module.exports = __webpack_public_path__ + "static/media/My-classes-student.0f5da898.png";